import { useEffect } from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { IconButton } from '@mui/material';

import { usePathname } from 'src/routes/hooks';

import { Iconify } from 'src/components/iconify';
import { Scrollbar } from 'src/components/scrollbar';

import { FormDivider } from 'src/auth/components/form-divider';

import { Nav, NavUl } from '../components';
import { NavList } from './nav-mobile-list';

import type { NavMainProps } from '../types';

// ----------------------------------------------------------------------

export type NavMobileProps = NavMainProps & {
  open: boolean;
  onClose: () => void;
  slots?: {
    topArea?: React.ReactNode;
    bottomArea?: React.ReactNode;
  };
};

export function NavMobile({ data, open, onClose, slots, sx }: NavMobileProps) {
  const pathname = usePathname();

  useEffect(() => {
    if (open) {
      onClose();
    }
  }, [pathname]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: [
            {
              display: 'flex',
              flexDirection: 'column',
              width: 'var(--layout-nav-mobile-width)',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
          ],
        },
      }}
    >
      {slots?.topArea ?? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img style={{ width: '120px', margin: '20px 0px' }} src="./assets/ms-logo2.png" />
        </Box>
      )}

      <Scrollbar fillContent>
        <Nav
          sx={{
            pb: 3,
            display: 'flex',
            flex: '1 1 auto',
            flexDirection: 'column',
          }}
        >
          <NavUl>
            {data.map((list) => (
              <NavList key={list.title} data={list} />
            ))}
          </NavUl>
        </Nav>
      </Scrollbar>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <FormDivider sx={{ width: '80%', margin: '15px' }} label="" />
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          margin: '0px 25px 15px 25px',
        }}
      >
        <IconButton
          onClick={() => window.open('https://www.facebook.com/melfarserviceudlejning', '_blank')}
        >
          <Iconify width={32} height={32} icon="socials:facebook" href="" />
        </IconButton>
        <IconButton
          onClick={() => window.open('https://www.instagram.com/melfarserviceudlejning/', '_blank')}
        >
          <Iconify width={32} height={32} icon="socials:instagram" />
        </IconButton>
      </div>
    </Drawer>
  );
}
